import { AlertCircle, ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';
import type { HumanError } from '../lib/errors.ts';
import { Button } from './ui/button.tsx';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible.tsx';

/** What happened · why · what to do · one button · "Подробнее" with the technical bits. */
export function ErrorCard({ error, extra }: { error: HumanError; extra?: ReactNode }) {
  const t = error.technical;
  return (
    <div role="alert" className="rounded-[16px] border border-bad/25 bg-bad/[.06] p-4">
      <div className="flex gap-3">
        <AlertCircle className="mt-0.5 size-5 shrink-0 text-bad" />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <p className="font-semibold">{error.title}</p>
          <p className="text-[14px] text-muted">{error.why}</p>
          <p className="text-[14px]">
            <span className="font-semibold">Что сделать: </span>
            {error.todo}
          </p>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            {error.action && (
              <Button size="sm" asChild>
                <a href={error.action.href}>{error.action.label}</a>
              </Button>
            )}
            {extra}
          </div>
          {(t.code ?? t.requestId ?? t.text) && (
            <Collapsible>
              <CollapsibleTrigger className="mt-2 inline-flex items-center gap-1 text-[13px] text-muted hover:text-fg [&[data-state=open]>svg]:rotate-180">
                Подробнее <ChevronDown className="size-3.5 transition" />
              </CollapsibleTrigger>
              <CollapsibleContent>
                <pre className="mt-2 whitespace-pre-wrap break-words rounded-lg bg-fill p-3 text-[12px] text-muted">
                  {[t.code && `код: ${t.code}`, t.requestId && `request_id: ${t.requestId}`, t.text]
                    .filter(Boolean)
                    .join('\n')}
                </pre>
              </CollapsibleContent>
            </Collapsible>
          )}
        </div>
      </div>
    </div>
  );
}
